import React from 'react';
import PropTypes from 'prop-types';

export default function SeasonDetailsVerticalRenderer ({
    journeySelector,
    dateTimePicker,
    passengers,
    railcard1617,
    railcardsWarning,
    smartcardDetails,
    smartcardInfo,
    smartcardMaintenance,
    promoDiscount
}) {
    return (
        <div>
            { smartcardInfo }
            { smartcardMaintenance }
            { journeySelector }
            { passengers }
            { dateTimePicker }
            { railcard1617 }
            { smartcardDetails }
            { railcardsWarning }
            { promoDiscount }
        </div>
    );
}

SeasonDetailsVerticalRenderer.propTypes = {
    journeySelector: PropTypes.node,
    tocSpecificSelector: PropTypes.node,
    dateTimePicker: PropTypes.node,
    passengers: PropTypes.node,
    railcard1617: PropTypes.node,
    railcardsWarning: PropTypes.node,
    smartcardDetails: PropTypes.node,
    smartcardMaintenance: PropTypes.node,
    smartcardInfo: PropTypes.node,
    promoDiscount: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/search/SeasonDetailsVerticalRenderer.js